import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SousTraitantsDto } from './dto/sous-traitants.dto'
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { PageResponse } from '../../../shared/data-access/http/dto/page-dto'

@Injectable({providedIn: 'root'})
export class SousTraitantsHttp {

  private static readonly endpoint = environment.baseUrl + '/sous-traitants'
  private readonly http = inject(HttpClient)

  findSousTraitants(
    keyword: string,
    codeChantier: string,
    page: number,
    size: number
  ): Observable<PageResponse<SousTraitantsDto>> {
    const params = new HttpParams()
      .set('keyword', keyword)
      .set('codeChantier', codeChantier)
      .set('page', page.toString())
      .set('size', size.toString())

    return this.http.get<PageResponse<SousTraitantsDto>>(
      SousTraitantsHttp.endpoint + '/find',
      { params }
    )
  }

}


